import React from "react";
import { PageHero } from "@/components/primitives";
import { EVENT } from "@/data/site";

const SECTIONS = [
  ["Who we are", `This website is operated by ${EVENT.organiser} for the Bharat Ethanol Forum 2026. We are committed to protecting the privacy of delegates, sponsors, exhibitors and visitors.`],
  ["Information we collect", "We collect information you provide through our forms — name, work email, organisation, role and country — when you register, request the brochure, run the calculator report, enquire about sponsorship or exhibiting, or contact us."],
  ["How we use it", "We use your information to process registrations and enquiries, send the resources you request, and share relevant forum updates. We do not sell your personal data."],
  ["Email communications", "By submitting a form you agree to receive event-related communications. You can unsubscribe at any time using the link in any email."],
  ["Data retention & security", "We retain submission data for as long as necessary to operate the event and apply reasonable safeguards to protect it."],
  ["Contact", `For any privacy request, email ${EVENT.email}.`],
];

export default function Privacy() {
  return (
    <>
      <PageHero overline="Legal" title="Privacy Policy" subtitle={`Last updated: ${EVENT.lastUpdated}.`} />
      <section className="bg-parchment py-16 md:py-24">
        <div className="mx-auto max-w-3xl space-y-8 px-6">
          {SECTIONS.map(([h, p]) => (
            <div key={h}>
              <h2 className="font-display text-xl font-bold text-navy">{h}</h2>
              <p className="mt-3 leading-relaxed text-navy/70">{p}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
